// adminDashboardLogin.js (COOKIE-BASED)

// Genereert de HTML van de loginpagina
export function adminDashboardLogin() {
  return `
    <section class="flex flex-col items-center justify-center py-12">
      <form id="adminLoginForm" class="w-full max-w-sm mx-auto bg-white/80 backdrop-blur-md p-8 rounded-2xl shadow-xl border border-gray-100">
        <h2 class="text-3xl font-semibold text-gray-800 mb-8 text-center">Admin Login</h2>

        <!-- Email -->
        <div class="mb-5">
          <label for="email" class="block text-sm font-medium text-gray-600 mb-2">Email</label>
          <input 
            type="email" 
            id="email" 
            name="email" 
            placeholder="admin@epcspainhomes.com"
            class="w-full px-4 py-3 border border-gray-200 rounded-lg text-gray-800 placeholder-gray-400 
                   focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-transparent transition"
            required
          >
          <span id="err-email" class="hidden text-sm text-red-500 mt-1"></span>
        </div>

        <!-- Password -->
        <div class="mb-5">
          <label for="password" class="block text-sm font-medium text-gray-600 mb-2">Password</label>
          <input 
            type="password" 
            id="password" 
            name="password" 
            placeholder="••••••••"
            class="w-full px-4 py-3 border border-gray-200 rounded-lg text-gray-800 placeholder-gray-400 
                   focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-transparent transition"
            required
          >
          <span id="err-password" class="hidden text-sm text-red-500 mt-1"></span>
        </div>

        <!-- Server error -->
        <div class="mb-4">
          <span id="serverError" class="hidden text-sm text-red-500 text-center block"></span>
        </div>

        <button 
          type="submit"
          class="w-full bg-emerald-600 hover:bg-emerald-700 text-white py-3 rounded-lg font-semibold shadow-sm 
                 transition focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:ring-offset-2"
        >
          Sign In
        </button>

      </form>
    </section>
  `;
}

// Koppelt functionaliteit aan het formulier
export function initAdminDashboardLoginLogic() {
  const form = document.getElementById("adminLoginForm");
  if (!form) return;

  const emailInput = document.getElementById("email");
  const passwordInput = document.getElementById("password");
  const serverError = document.getElementById("serverError");

  const showError = (id, msg) => {
    const el = document.getElementById(id);
    if (!el) return;
    el.textContent = msg;
    el.classList.remove("hidden");
  };

  const hideError = (id) => {
    const el = document.getElementById(id);
    if (el) el.classList.add("hidden");
  };

  // Realtime validatie
  emailInput.addEventListener("input", () => {
    const value = emailInput.value.trim();
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    value && !regex.test(value)
      ? showError("err-email", "Enter a valid email address")
      : hideError("err-email");
  });

  passwordInput.addEventListener("input", () => {
    const value = passwordInput.value.trim();
    value && value.length < 5
      ? showError("err-password", "Password must be at least 5 characters")
      : hideError("err-password");
  });

  // Submit handler — COOKIE LOGIN
  form.addEventListener("submit", async (e) => {
    e.preventDefault();
    hideError("err-email");
    hideError("err-password");
    serverError.classList.add("hidden");

    const email = emailInput.value.trim();
    const password = passwordInput.value.trim();

    if (!email || !password) {
      if (!email) showError("err-email", "Email is required");
      if (!password) showError("err-password", "Password is required");
      return;
    }

    try {
      const response = await fetch("/api/adminlogin", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password }),
        credentials: "include" // 🔥 Belangrijk! Stuurt adminToken-cookie mee
      });

      const data = await response.json();

      if (response.ok) {
        // 🎉 Backend heeft adminToken-cookie gezet (HttpOnly)
        // → Geen localStorage meer nodig!

        window.location.href = "/portaal/adminDashboard";

      } else {
        showError("serverError", data.error || "Login mislukt");
      }

    } catch (err) {
      console.error("Admin login fout:", err);
      showError("serverError", "Netwerkfout tijdens inloggen");
    }
  });
}
